import React from 'react'
import { getAvailableCount, getImage, getUnitTags } from '../helpers'
import { UnitMaster } from '../reducer'
import {
  UnitsCardActionButton,
  UnitsCardAvailability,
  UnitsCardBody,
  UnitsCardDescription,
  UnitsCardHeader,
  UnitsCardImage,
  UnitsCardImageFrame,
  UnitsCardMedia,
  UnitsCardPrice,
  UnitsCardPriceLabel,
  UnitsCardPriceValue,
  UnitsCardRoot,
  UnitsCardTag,
  UnitsCardTagList,
  UnitsCardTitle,
  UnitsCardTitleGroup,
} from '../styled'

export const UnitCard: React.FC<{
  unit: UnitMaster
  onReserve: () => void
}> = ({ unit, onReserve }) => {
  const availableCount = getAvailableCount(unit)

  return (
    <UnitsCardRoot className="units-card">
      <UnitsCardMedia className="units-card__media">
        <UnitsCardImageFrame className="units-card__image-frame">
          <UnitsCardImage
            className="units-card__image"
            src={getImage(unit.size)}
            alt={`${unit.size} storage unit`}
          />
        </UnitsCardImageFrame>
        <UnitsCardTagList className="units-card__tags">
          {getUnitTags(unit).map((tag) => (
            <UnitsCardTag key={tag} className="units-card__tag">
              {tag}
            </UnitsCardTag>
          ))}
        </UnitsCardTagList>
      </UnitsCardMedia>

      <UnitsCardBody className="units-card__body">
        <UnitsCardHeader className="units-card__header">
          <UnitsCardTitleGroup className="units-card__title-group">
            <UnitsCardTitle className="units-card__title">
              {unit.size}
            </UnitsCardTitle>
            <UnitsCardAvailability
              className="units-card__availability"
              isavailable={availableCount > 0 ? 1 : 0}
            >
              {availableCount > 0
                ? `${availableCount} units available`
                : 'Currently full'}
            </UnitsCardAvailability>
          </UnitsCardTitleGroup>

          <UnitsCardPrice className="units-card__price">
            <UnitsCardPriceLabel className="units-card__price-label">
              Monthly Rate
            </UnitsCardPriceLabel>
            <UnitsCardPriceValue className="units-card__price-value">
              ${unit.price}
            </UnitsCardPriceValue>
          </UnitsCardPrice>
        </UnitsCardHeader>

        <UnitsCardDescription className="units-card__description">
          {unit.description}
        </UnitsCardDescription>

        <UnitsCardActionButton
          className="units-card__action"
          onClick={onReserve}
          variant="outlined"
          fullWidth
        >
          Reserve Now
        </UnitsCardActionButton>
      </UnitsCardBody>
    </UnitsCardRoot>
  )
}
